import eq from 'ember-truth-helpers/helpers/eq';
import SurveyBasedComponent from 'parog-web/components/forc/abstract/survey-based-component';
import Provider from 'parog-web/components/forc/provider';

export default class PersonalBackgroundFormComponent extends SurveyBasedComponent {
  static override forcDisplayName = 'Antécédents personnels et familiaux';
  static override fullComponentId = 'personal-background/form';

  override computePayload() {
    const payload = super.computePayload();

    if (payload.definitiveContraception !== 'no') {
      delete payload.contraceptionMethod;
    }

    return payload;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>

        <h4 class='ui dividing header'>Antécédents psychiatriques personnels</h4>

        <div class='field'>
          <Form.TextArea
            @labelName="Antécédents d'hospitalisation en psychiatrie"
            @propertyName='hospitalPsyBackground'
          />
          <span class='ui grey text'>Préciser pour chaque hospitalisation la
            date, le mode (SL ou SSC), le motif</span>
        </div>

        <div class='field'>
          <Form.TextArea
            @labelName='Autres antécédents psychiatriques'
            @propertyName='otherPsyBackground'
          />
          <span class='ui grey text'>Ex: TCA type anorexie-bouimie dans
            l'adolescence, trouble panique avec agoraphobie en rémission,
            trouble de l'attention avec hyperactivité dans l'enfance</span>
        </div>

        <div class='field'>
          <Form.TextArea
            @labelName='Traitement antérieur'
            @propertyName='previousTreatments'
          />
        </div>

        <h4 class='ui dividing header'>Antécédents médico-chirurgicaux
          personnels</h4>

        <div class='field'>
          <Form.TextArea @propertyName='personalChirurgicalBackground' />
        </div>

        {{#if (eq @patient.gender 'female')}}
          <h4 class='ui dividing header'>Contraception</h4>

          <div class='two fields'>
            <Form.ConditionalRadioGroup
              @propertyName='definitiveContraception'
              @conditionalValue='no'
              as |ConditionalRadioGroup showConditionalBlock|
            >

              <div class='field'>
                <ConditionalRadioGroup.AlignedFieldsRadioGroup
                  @title='Ménopause ou contraception définitive'
                  as |Group|
                >
                  {{!
                Unset contraceptionMethod if definitiveContraception === "no".
                Manually wrapping Group.Radio inside a .field because our modifiers cannot be forwared to Group.FieldRadio
              }}
                  <Group.FieldRadio @value='yes' @label='Oui' />
                  <Group.FieldRadio @value='no' @label='Non' />
                  <Group.FieldRadio @value='unknown' @label='Pas de réponse' />

                </ConditionalRadioGroup.AlignedFieldsRadioGroup>
              </div>

              {{! using visibility: hidden to avoid layout shift when showConditionalBlock is toggled }}
              <div class='field {{unless showConditionalBlock "invisible"}}'>
                <Form.Dropdown
                  @labelName='Contraception en cours'
                  @propertyName='contraceptionMethod'
                  @placeholder='Choisir le type de contraception'
                  as |dropdown|
                >
                  <dropdown.Item
                    @value='Aucune ou contraception locale uniquement'
                    @key='none'
                  />
                  <dropdown.Item
                    @value='Dispositif intra-utérin (stérilet cuivre ou hormonal)'
                    @key='intra'
                  />
                  <dropdown.Item
                    @value='Contraception hormonale - prise continue'
                    @key='hormonalContinuous'
                  />
                  <dropdown.Item
                    @value='Contraception hormonale - prise discontinue'
                    @key='hormonalScattered'
                  />
                </Form.Dropdown>
              </div>
            </Form.ConditionalRadioGroup>
          </div>
        {{/if}}

        <h4 class='ui dividing header'>Antécédents familiaux psychiatriques et
          physiques</h4>

        <div class='field'>
          <Form.TextArea @propertyName='familyPsyAndPhysicalBackground' />
        </div>
      </:content>
    </Provider>
  </template>
}
